import { createCRUDEndpoints } from '@/api/factory/crud';
import { DistributorJSON } from '@/store/modules/distributors/distributor';

type ListParams =
  | {
      status?: 0 | 1;
    }
  | undefined;

export const { list, get, store, remove, restore } = createCRUDEndpoints<
  DistributorJSON,
  ListParams,
  'id',
  DistributorJSON[]
>({
  slug: 'distributor',
});
